import React from 'react'
import { Consumer } from '../../context';
import { Link } from 'react-router-dom';
import ImageCardDark from '../Cards/ImageCardDark';
import {v4 as uuid} from 'uuid'

function PopCultureSection() {
    return (
        <Consumer>
            {(value) => {
                const {popCulture} = value;
                return (
                    <div>
                        <div className="container-fluid lightSection">
                            <div className="container">
                                <div className="display-5 text-center pt-5 pb-3">
                                    P o p - C u l t u r e
                                </div>
                                <div className="row pb-3 px-5 font-monospace">
                                    {popCulture.slice(0,3).map((ill) => (
                                        <div key={uuid()} className="col-12 col-md-6 col-lg-4 py-lg-5 py-3">
                                            <ImageCardDark
                                                //section={popCulture}
                                                image={ill} />
                                        </div>
                                    ))}
                                </div>
                                <div className="pb-3">
                                    <Link to="/gallery/popCulture" className="sectionlink">
                                        <h5 className="text-end pe-5 font-monospace">
                                            View all <i className="fas fa-arrow-right align-middle"></i>
                                        </h5>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default PopCultureSection;